export default "__VITE_ASSET__Bb02VE0x__"